(() => {
  if (window.sbfAdvertorialSticky) return;
  window.sbfAdvertorialSticky = true;
  const instances = new Map();
  let frame = 0;

  function update() {
    frame = 0;
    const height = window.innerHeight;
    instances.forEach((state, root) => {
      if (!root.isConnected) { instances.delete(root); return; }
      const boxes = state.ctas.map((cta) => cta.getBoundingClientRect());
      const offer = state.offers?.getBoundingClientRect();
      const footer = state.footer?.getBoundingClientRect();
      let index = -1;
      boxes.forEach((box, i) => { if (box.height && box.bottom <= 0) index = i; });
      const next = boxes[index + 1];
      const offerVisible = offer && offer.top < height && offer.bottom > 0;
      const beforePostOfferCta = offer && offer.bottom <= 0 &&
        (index < 0 || boxes[index].bottom <= offer.bottom);
      const show = index >= 0 && !offerVisible && !beforePostOfferCta &&
        !(footer && footer.top < height) && !(next && next.top < height);
      if (show && state.current !== state.ctas[index]) {
        state.current = state.ctas[index];
        state.link.textContent = state.current.textContent.trim();
        state.link.setAttribute('href', state.current.getAttribute('href'));
      }
      state.bar.hidden = !show;
    });
  }

  function schedule() {
    if (!frame) frame = requestAnimationFrame(update);
  }

  function init(scope = document) {
    const roots = scope.matches?.('[data-ad-section]') ? [scope] :
      scope.querySelectorAll('[data-ad-section]');
    roots.forEach((root) => {
      if (instances.has(root)) return;
      const bar = root.querySelector('.ad-sticky-cta');
      const link = bar?.querySelector('[data-ad-sticky-link]');
      if (!bar || !link) return;
      instances.set(root, {
        bar, link, current: null,
        ctas: [...root.querySelectorAll('a.ad-cta-track')].filter((a) =>
          a.getAttribute('href') === '#gift-offers' && !bar.contains(a)),
        offers: root.querySelector('#gift-offers'),
        footer: root.querySelector('.ad-footer')
      });
    });
    schedule();
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('load', schedule, { once: true });
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', () => schedule());
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else { init(); }
})();
